module.exports = __webpack_public_path__ + "static/media/compassionate1.9fedd73c.png";